<div class="verify-otp-comp-container">
  <div class="verify-otp-form">
    <div class="header">
      <button
        pButton
        (click)="backButton()"
        class="back-button"
        severity="secondary"
        icon="ph ph-caret-left"
        aria-label="Back"></button>
      <span class="title-text">{{ 'doktar_app.auth.enter_code_title' | translate }}</span>
      <span class="subtitle-text">
        @if (loginInputType === 'email') {
          {{ 'doktar_app.auth.enter_code_email_description' | translate: { arg1: verifyOtpInfo } }}
        } @else if (loginInputType === 'phone') {
          {{ 'doktar_app.auth.enter_code_phone_description' | translate: { arg1: verifyOtpInfo } }}
        }
      </span>
    </div>

    <p-inputotp
      [(ngModel)]="otpValue"
      [maxlength]="6"
      [length]="6"
      [integerOnly]="true"
      [autofocus]="true"
      class="custom-otp-input"
      [ngClass]="{ 'error-border': !otpValidationStatus }"
      (onBlur)="otpValidationStatus = true">
    </p-inputotp>

    <div class="verify-otp-buttons">
      <p-button
        [text]="true"
        [link]="true"
        [label]="
          resendCodeCounter === 0
            ? ('doktar_app.auth.enter_code_resend_button' | translate)
            : ('doktar_app.auth.enter_code_resend_button_w_time' | translate: { arg1: formattedResendCodeCounter })
        "
        (click)="resendCodeTrigger()"
        [disabled]="resendCodeCounter !== 0"></p-button>
      <button
        pButton
        (click)="confirmVerifyOtp()"
        class="continue-button"
        [label]="'doktar_app.common.confirm_button' | translate"
        [disabled]="!otpValue || otpValue.toString().length !== 6"></button>
    </div>
  </div>
</div>
